import Login from "../pages/login/Login";
import {Page} from "../interfaces/router/Page";


export const login: Page = {
    path: "/",
    view: Login,
    exact: true
}